<template>
    <div class="main-cn" >
        <div class="main-hd" >
            <h4>编辑线索</h4>
        </div>
        <div class="main-bd mg20" >
            <el-row>
                <el-col>
                    <clue-form v-if="model.id > 0" :model="model" :isEdit="true" @submit="submitForm" ></clue-form>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>

import ClueService from "~/services/SaleClues"
import clueForm from "~/views/clue/form.vue";
export default {
    data() {
        return {
            model: {
                id: '',
            }
        }
    },
    components: {
        clueForm
    },
    created() {
        this.getCurrentClue(this.$route.query['id']);
    },
    methods: {
        getCurrentClue(id) {
            ClueService.getInfo(id).then( res => {
                if(res.code == 0) {
                    if (res.data) {
                        this.model = Object.assign(this.model, res.data);
                    }
                    this.model = ClueService.createModel(this.model);
                }
            })
        },
        
        submitForm(params) {
            ClueService.editSaleClue(Object.assign( params, {id: this.model.id} )).then( res => {
                if(res.code == 0) {
                    this.$message({
                        message: '编辑成功',
                        type: 'success'
                    });
                    this.$router.push({
                        path: this.$route.query['referer']
                    });
                }
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/clue/edit.vue